import { z } from "zod";
import { ZDateish, ZObjectIdString, ZProjectNo } from "./foundationSchema";
/** One article per project and import run, independent of the source system. */
export const ZArticleSnapshot = z.object({
    _id: ZObjectIdString.optional(),
    projectNo: ZProjectNo,
    // Resolved within the source system's import-run collection.
    runId: ZObjectIdString,
    capturedAt: ZDateish,
    compCode: z.string().min(1),
    name: z.string().nullable().optional(),
    responsibility: z.string().nullable().optional(),
    toBeDrawn: z.boolean().nullable().optional(),
    properties: z.record(z.string(), z.string().nullable()).optional(),
    source: z.object({
        system: z.string().min(1),
        articleId: z.union([z.string(), z.number()]).nullable().optional(),
    }),
});
export const ARTICLE_SNAPSHOT_INDEX = {
    key: { projectNo: 1, runId: 1, compCode: 1 },
    options: { unique: true, name: "articles_projectNo_runId_compCode_uq" },
};
